module.exports = __webpack_public_path__ + "img/gp-x.dfad1ed4.png";